module.exports = __webpack_public_path__ + "media/images/emblems/Worb-coat_of_arms-12422b372fddd401d962d9af3a78c34e.svg";